export default __webpack_public_path__ + "static/media/gift5.d254321b.png";